<template>
    <div>
        <label>
            Beschädigte Bereiche bitte kennzeichnen
        </label>

        <csp-record-damage-image-select :damage-form="damageForm" @change="setDamageImage"/>
    </div>
</template>

<script>
    import Form from '@form/Form';

    export default {
        props: {
            damageForm: {
                type: Form,
                required: true,
            },
        },
        data() {
            return {
            }
        },
        methods: {
            setDamageImage(pngImageData) {
                this.damageForm.getData().damageImage = pngImageData;
            },
        },
    }
</script>
